import { FormBuilder, FormGroup } from "@angular/forms";
import { CalendarControl, CheckboxControl, InputNumberControl, DropdownControl, InputTextControl, FileUploadControl, InputMaskControl, LabelControl, InputTextareaControl, SubFormularioControl } from "./form-controls";
import { ControlType } from "../enums/ControlType";
import { BaseControl } from "./form-base-controls";

export class FormPage {
    private _name: string;
    private _title: string;
    private _hideTitle ?: boolean;

    private _controls: BaseControl<any>[];
    private _controlRows: BaseControl<any>[][];
    private _formGroup: FormGroup<{}>    
    private fb: FormBuilder;
    submitted: boolean = false;

    constructor(data: FormPage) {
        this.fb = new FormBuilder();
        this._name = data.name;
        this._title = data.title;
        this._hideTitle = data.hideTitle;
        this._controls = [];
        this._formGroup = this.fb.group({});
        this._controlRows = []
    }
    //#region Getters and Setters
    get name(): string {
        return this._name;
    }

    set name(name: string) {
        this._name = name;
    }

    get title(): string {
        return this._title;
    }

    set title(title: string) {
        this._title = title;
    }

    get hideTitle(): boolean {
        return this._hideTitle ?? false;
    }

    set hideTitle(value: boolean) {
        this._hideTitle = (value === false) ? undefined : value;
    }

    get controls(): BaseControl<any>[] {
        return this._controls;
    }

    get controlRows(): BaseControl<any>[][] {
        return this._controlRows;
    }

    intializeControlRows() {
        let rows: BaseControl<any>[][] = [];
        let currentRow: BaseControl<any>[] = [];

        this._controls.forEach((control) => {
            if (control.startOnNewLine) {
                rows.push(currentRow);
                currentRow = [];
            }
            currentRow.push(control);
        });

        // Push the last row if it's not empty
        if (currentRow.length > 0) {
            rows.push(currentRow);
        }

        this._controlRows = rows;
    }

    get formGroup(): FormGroup<{}> {
        return this._formGroup;
    }
    //#endregion Getters and Setters

    //#region create/load
    createNewControlItem(newControlName: string) {
        let newControl = new InputTextControl({ name: newControlName, label: newControlName });
        this._controls.push(newControl);
        this._formGroup?.addControl(newControl.name, newControl.FormControl);
        this.intializeControlRows();
    }

    initializeControlByType(type: ControlType, data: any){
        let control: any;
        switch (type) {
            case ControlType.Text: {
                control = new InputTextControl(data);
                break;
            }
            case ControlType.Number: {
                control = new InputNumberControl(data);
                break;
            }
            case ControlType.InputMask: {
                control = new InputMaskControl(data);
                break;
            }
            case ControlType.Dropdown: {
                control = new DropdownControl(data);
                break;
            }
            case ControlType.Checkbox: {
                control = new CheckboxControl(data);
                break;
            }
            case ControlType.Calendar: {
                control = new CalendarControl(data);
                break;
            }case ControlType.FileUpload: {
                control = new FileUploadControl(data);
                break;
            }case ControlType.Label: {
                control = new LabelControl(data);
                break;
            }case ControlType.TextArea: {
                control = new InputTextareaControl(data);
                break;
            }case ControlType.SubFormulario: {
                control = new SubFormularioControl(data);
                break;
            }
            default:
        }
        return control;
    }

    loadControl(data: any) {
        let newControl = this.initializeControlByType(data.type, data);
        this._controls.push(newControl);
        this._formGroup?.addControl(newControl.name, newControl.FormControl);

    }
    //#endregion create/load

    findControlIndex(controlName: string): number {
        return this._controls.findIndex(control => control.name === controlName);
    }

    findControl(controlName: string): BaseControl<any> | undefined {
        return this._controls.find(control => control.name === controlName);
    }

    toJSON(): any {
        return {
            name: this._name,
            title: this._title,
            controls: this._controls.map(control => control.toJSON()),
            hideTitle: this._hideTitle
        }
    }
}
